import { Button, Flex, Stack, ThemeIcon, Title } from '@mantine/core';
import { IconAlertCircle, IconError404 } from '@tabler/icons-react';
import * as React from 'react';
import { Link } from 'react-router-dom';

import Text from 'components/shared/Text';
import { ROUTES } from 'configs/routes';
import { useResponsiveProp } from 'hooks/useResponsiveProp';

import s from './ErrorPage.module.scss';

type Props = {
  isNotFound?: boolean;
  error?: string;
  withNavigateToMain?: boolean;
};

const ErrorLayout: React.FC<Props> = ({ isNotFound, error, withNavigateToMain = true }: Props) => {
  const align = useResponsiveProp({ desktop: 'center', phone: 'flex-start' });
  const textAlign = useResponsiveProp({ desktop: 'center', phone: 'left' });
  const size = useResponsiveProp({ desktop: 'lg', phone: 'md' });
  const titleOrder = useResponsiveProp({ desktop: 1, phone: 2 });

  return (
    <Flex justify="center" className={s.root}>
      <div className={s.root__container}>
        <Stack gap="xl">
          <Stack gap="lg" align={align}>
            <ThemeIcon radius="md" size="xl" variant="outline" color="gray">
              {isNotFound ? (
                <IconError404 color="var(--mantine-color-text)" />
              ) : (
                <IconAlertCircle color="var(--mantine-color-text)" />
              )}
            </ThemeIcon>

            <Stack align={align} gap="sm">
              <Title order={titleOrder} variant="text" ta={textAlign}>
                {isNotFound ? 'Ошибка 404' : 'Произошла ошибка'}
              </Title>
              <Text ta={textAlign} c="gray">
                {isNotFound &&
                  'Страница не найдена или не существует. Возможно, вы ошиблись при вводе адреса в строку в браузере.'}
                {!isNotFound && error}
                {!isNotFound && !error && 'Нам очень жаль, уже работаем над исправлениями'}
              </Text>
            </Stack>
          </Stack>
          {withNavigateToMain && (
            <Button fullWidth size={size} component={Link} to={ROUTES.root.create()}>
              На главную
            </Button>
          )}
        </Stack>
      </div>
    </Flex>
  );
};

export default ErrorLayout;
